var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6078: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	93649: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	67629: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	65428: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	48394: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	44525: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	24951: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	4763: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/models-environment */ 41078))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/models-environment",

	},
	68983: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 27964))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-state-store",

	},
	95807: {
		fallback: () => (__webpack_require__.e("node_modules_bootstrap_dist_js_bootstrap_esm_js").then(() => (() => (__webpack_require__(/*! bootstrap */ 83527))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.3.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "bootstrap",

	},
	81545: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-icon */ 56670))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-icon",

	},
	47642: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 11925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store-devtools",

	},
	65541: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-libs_shared_ui-alert_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-alert */ 33433))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-alert",

	},
	4357: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-libs_shared_ui-panel_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-panel */ 9673))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-panel",

	},
	78807: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-logging */ 68208))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-logging",

	},
	13621: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/feature-load-remote */ 59608))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/feature-load-remote",

	},
	63350: {
		fallback: () => (__webpack_require__.e("node_modules_microsoft_applicationinsights-web_dist-es5_applicationinsights-web_js").then(() => (() => (__webpack_require__(/*! @microsoft/applicationinsights-web */ 75205))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "3.4.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/applicationinsights-web",

	},
	50064: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	82512: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	69930: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	69347: {
		fallback: () => (__webpack_require__.e("node_modules_auth0_auth0-spa-js_dist_auth0-spa-js_production_esm_js").then(() => (() => (__webpack_require__(/*! @auth0/auth0-spa-js */ 86377))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.21.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-spa-js",

	},
	69066: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	98969: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-route-state_snelstart_util-route-state"), __webpack_require__.e("default-libs_shared_ui-button_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-button */ 36071))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-button",

	},
	2983: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-route-state */ 23140))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-route-state",

	},
	45497: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/ui-loading */ 8391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-loading",

	},
	52191: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-feature-flag_snelstart_util-feature-flag"), __webpack_require__.e("default-libs_shared_ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui */ 51874))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui",

	},
	80271: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_bootstrap_bootstrap"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-tooltip */ 6408))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-tooltip",

	},
	78001: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-feature-flag */ 86266))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-feature-flag",

	},
	47051: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environ-0a508c"), __webpack_require__.e("default-libs_shared_util_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/util */ 13728))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util",

	},
	40107: {
		fallback: () => (__webpack_require__.e("node_modules_bufbuild_protobuf_dist_esm_wire_index_js").then(() => (() => (__webpack_require__(/*! @bufbuild/protobuf/wire */ 6174))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.12.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bufbuild/protobuf/wire",

	},
	95341: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_auth0_auth0-angular_fesm2022_auth0-auth0-angular_mjs")]).then(() => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-angular",

	},
	66832: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/angular-jwt",

	},
	20188: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	65041: {
		fallback: () => (__webpack_require__.e("default-libs_shared_util-events_src_index_ts").then(() => (() => (__webpack_require__(/*! @snelstart/util-events */ 43532))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-events",

	},
	21751: {
		fallback: () => (__webpack_require__.e("node_modules_broadcast-channel_dist_esbrowser_index_js").then(() => (() => (__webpack_require__(/*! broadcast-channel */ 77547))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "broadcast-channel",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		6078
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		93649
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		67629
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		65428
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		48394
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		44525
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		24951
	],
	"default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environ-0a508c": [
		4763,
		68983
	],
	"default-webpack_sharing_consume_default_bootstrap_bootstrap": [
		95807
	],
	"default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon": [
		81545
	],
	"apps_shells_kyc-web-shell_src_bootstrap_ts": [
		47642,
		65541,
		4357,
		78807,
		13621,
		63350
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		50064
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		82512,
		69930
	],
	"default-node_modules_auth0_auth0-angular_fesm2022_auth0-auth0-angular_mjs": [
		69347
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		69066
	],
	"default-libs_shared_ui-alert_src_index_ts": [
		98969
	],
	"default-webpack_sharing_consume_default_snelstart_util-route-state_snelstart_util-route-state": [
		2983
	],
	"default-libs_shared_ui-button_src_index_ts": [
		45497,
		52191,
		80271
	],
	"default-webpack_sharing_consume_default_snelstart_util-feature-flag_snelstart_util-feature-flag": [
		78001
	],
	"default-libs_shared_ui_src_index_ts": [
		47051
	],
	"default-libs_shared_util-events_src_index_ts": [
		40107
	],
	"default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular": [
		95341
	],
	"default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt": [
		66832
	],
	"default-libs_shared_util_src_index_ts": [
		20188,
		65041,
		21751
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}